// extracted by mini-css-extract-plugin
module.exports = {"SettingsContent":"notifications_SettingsContent__2jKWJ","NotificationModule":"notifications_NotificationModule__1yFbh","spinner":"notifications_spinner__1BG7E"};